// Catálogo genérico de profesiones y ocupaciones (nivel mundial), para autocompletado.
export const PROFESIONES_MUNDO = [
  // Ingeniería
  "Ingeniero Civil", "Ingeniero de Sistemas", "Ingeniero Industrial", "Ingeniero Electrónico",
  "Ingeniero Eléctrico", "Ingeniero Mecánico", "Ingeniero Químico", "Ingeniero Ambiental",
  "Ingeniero Agrónomo", "Ingeniero de Minas", "Ingeniero de Petróleos", "Ingeniero Biomédico",
  "Ingeniero Aeroespacial", "Ingeniero Naval", "Ingeniero de Telecomunicaciones",
  "Ingeniero de Software", "Ingeniero de Datos", "Ingeniero de Alimentos", "Ingeniero Forestal",
  "Ingeniero Agroindustrial", "Ingeniero Automotriz", "Ingeniero de Sonido",

  // Tecnología
  "Desarrollador de Software", "Desarrollador Web", "Desarrollador Móvil", "Arquitecto de Software",
  "Administrador de Sistemas", "Administrador de Redes", "Analista de Datos", "Científico de Datos",
  "Especialista en Ciberseguridad", "Diseñador UX/UI", "Product Manager", "Scrum Master",
  "Analista de Sistemas", "Soporte Técnico", "Especialista en Inteligencia Artificial",
  "Especialista en Cloud Computing", "DevOps Engineer", "QA Tester",

  // Salud
  "Médico General", "Médico Cirujano", "Pediatra", "Ginecólogo", "Cardiólogo", "Dermatólogo",
  "Psiquiatra", "Neurólogo", "Oftalmólogo", "Ortopedista", "Anestesiólogo", "Radiólogo",
  "Odontólogo", "Enfermero", "Enfermera Jefe", "Auxiliar de Enfermería", "Fisioterapeuta",
  "Fonoaudiólogo", "Nutricionista", "Psicólogo", "Psicólogo Clínico", "Terapeuta Ocupacional",
  "Bacteriólogo", "Optómetra", "Paramédico", "Veterinario", "Tecnólogo en Salud",
  "Instrumentador Quirúrgico", "Farmacéutico", "Regente de Farmacia",

  // Derecho y ciencias sociales
  "Abogado", "Juez", "Fiscal", "Notario", "Politólogo", "Sociólogo", "Trabajador Social",
  "Antropólogo", "Historiador", "Criminólogo", "Internacionalista", "Diplomático",

  // Economía, administración y finanzas
  "Administrador de Empresas", "Economista", "Contador Público", "Auditor", "Analista Financiero",
  "Analista de Riesgos", "Actuario", "Especialista en Comercio Exterior", "Gerente de Proyectos",
  "Gerente Comercial", "Gerente de Recursos Humanos", "Consultor Empresarial", "Banquero",
  "Asesor Financiero", "Corredor de Bolsa", "Especialista en Marketing", "Publicista",
  "Community Manager", "Especialista en Ventas", "Ejecutivo de Cuenta", "Emprendedor",

  // Educación
  "Docente", "Profesor Universitario", "Rector", "Coordinador Académico", "Pedagogo",
  "Licenciado en Educación", "Bibliotecólogo", "Investigador", "Orientador Escolar",

  // Ciencias exactas y naturales
  "Físico", "Químico", "Matemático", "Estadístico", "Biólogo", "Geólogo", "Astrónomo",
  "Meteorólogo", "Oceanógrafo", "Ecólogo", "Bioquímico", "Genetista",

  // Arquitectura, arte y diseño
  "Arquitecto", "Diseñador Gráfico", "Diseñador Industrial", "Diseñador de Modas",
  "Fotógrafo", "Artista Plástico", "Escultor", "Ilustrador", "Animador 3D", "Editor de Video",
  "Cineasta", "Director de Arte", "Músico", "Compositor", "Actor", "Bailarín",

  // Comunicación
  "Periodista", "Comunicador Social", "Locutor", "Presentador", "Redactor",
  "Traductor", "Intérprete", "Relacionista Público",

  // Agropecuario y ambiental
  "Agrónomo", "Zootecnista", "Médico Veterinario Zootecnista", "Ambientalista",
  "Ingeniero Pesquero", "Silvicultor", "Técnico Agropecuario",

  // Oficios y técnicos
  "Electricista", "Plomero", "Soldador", "Mecánico Automotriz", "Carpintero", "Albañil",
  "Técnico en Refrigeración", "Técnico Electrónico", "Técnico en Sistemas", "Operario de Maquinaria",
  "Conductor", "Conductor de Transporte Pesado", "Piloto Comercial", "Piloto de Drones",
  "Chef", "Cocinero", "Panadero", "Repostero", "Barbero", "Estilista", "Maquillador",
  "Sastre", "Modisto", "Tapicero", "Pintor de Obra", "Vidriero", "Técnico en Mantenimiento",
  "Instalador de Redes", "Técnico en Telecomunicaciones",

  // Construcción e industria
  "Maestro de Obra", "Topógrafo", "Delineante", "Supervisor de Obra", "Inspector de Calidad",
  "Operario Industrial", "Técnico Industrial",

  // Logística, transporte y seguridad
  "Especialista en Logística", "Analista de Comercio Exterior", "Agente Aduanero",
  "Piloto de Aviación", "Azafata / Auxiliar de Vuelo", "Capitán de Barco", "Marino Mercante",
  "Oficial de Policía", "Militar", "Guardia de Seguridad", "Bombero", "Socorrista",

  // Turismo y servicios
  "Guía Turístico", "Administrador Hotelero", "Chef Ejecutivo", "Bartender", "Meteorólogo Aeronáutico",
  "Agente de Viajes", "Recepcionista", "Asistente Administrativo", "Secretario Ejecutivo",

  // Deporte
  "Entrenador Deportivo", "Preparador Físico", "Árbitro Deportivo", "Deportista Profesional",
  "Fisiólogo del Ejercicio",

  // Otros
  "Ama de Casa", "Estudiante", "Independiente", "Pensionado", "Empresario", "Otro",
];
